import React, {useEffect, useLayoutEffect, useRef, useState} from "react";
import {Container, Row, Col} from "react-bootstrap";
import {changeView, toggleLoader} from "../../shared/actions/setting";
import {REPORT_NAMES, VIEW} from "../../shared/util/enum";
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import {getUserId} from "../../shared/authentication/authentication";
import {toast} from "react-toastify";
import {useParams,useHistory} from "react-router-dom";
import {dateFormat, isEmpty, storeInLocalStorage} from "../../shared/util/utils";
import {getSelectedMachine} from "../../actions/machine";
import { getSelectedReport } from "../../actions/report";

const useShrinkToFit = (text, maxFontSize, minFontSize = 12) => {
    const ref = useRef(null);
    const [fontSize, setFontSize] = useState(maxFontSize);

    useLayoutEffect(() => {
        const el = ref.current;
        if (!el) {
            return;
        }
        let size = maxFontSize;
        el.style.fontSize = `${size}px`;
        while (el.scrollWidth > el.clientWidth && size > minFontSize) {
            size -= 1;
            el.style.fontSize = `${size}px`;
        }
        setFontSize(size);
    }, [text, maxFontSize, minFontSize]);

    return {ref, fontSize};
}

const BodyValue = ({label, value, columns}) => {
    const {ref, fontSize} = useShrinkToFit(value, 24);

    return <div className={columns === 3 ? "col-4" : "col-6"}>
        <div className="sensor-detailsDepartment">
            <div className="sensor-Name-reportList">{label}</div>
            <div ref={ref} style={{fontSize}} className="sensor-value-reportList limit-chara-varna">
                {value}
            </div>
        </div>
    </div>
}

const ReportItem = ({title, data, bodyData, onClick}) => {
    const mainValue = useShrinkToFit(data, 28);

    return <Col xl={4} lg={6} >
    <div className="single-card sa-cursor">
        <div className="single-card-header-departmentList ">
            <div className="row">
                <div className="col-12">
                    <div className="card-header-text-departmentList">
                        <div className="heading-machine">{title}</div>
                    </div>
                </div>
            </div>
        </div>
        <div className="single-card-contentReportList" onClick={onClick}>
            <div className="reportListPercentage limit-chara-varna">
                <label ref={mainValue.ref} style={{fontSize: mainValue.fontSize}}>
                    {data}
                </label>
            </div>
            <div className="row p-1">
                    {
                        bodyData && Object.keys(bodyData).map((item,index) => {
                            return <BodyValue key={index} label={item} value={bodyData[item]} columns={Object.keys(bodyData).length}/>
                        })
                    }
            </div>
        </div>
    </div>
 </Col>
}

const isMissing = (value) => value === undefined || value === null || value === '' || !Number.isFinite(Number(value));
// Drop decimals (no rounding) and group thousands, e.g. 10250.52 -> "10,250"
const formatNumber = (value) => (Math.trunc(Number(value)) || 0).toLocaleString('en-US');

const formatRaw = (value) => isMissing(value) ? '0' : formatNumber(value);
const formatPercent = (value) => isMissing(value) ? '0' : `${formatNumber(value)} %`;
const formatWithUnit = (value, unit = '') => isMissing(value) ? '0' : `${formatNumber(value)}${unit ? ' ' + unit : ''}`;


const ReportList = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const {machineID} = useParams();
    const {departmentID} = useParams();
    const [reportList, setReportList] = useState({});
    const selectedMachine = useSelector(state => {
        return state.machine.selectedMachine;
    });
    const selectedReportType = useSelector(state => {
        return state.reportList.selectedReportType;
    });
    const selectedShiftType = useSelector(state => {
        return state.reportList.selectedShiftType;
    });
    const todayDate = dateFormat(new Date());
    const fromDate = selectedReportType ? selectedReportType.fromDate : todayDate;
    const toDate = selectedReportType ? selectedReportType.toDate : todayDate;

    useEffect(() => {
        if (!isEmpty(selectedMachine)) {
            return;
        }

        dispatch(toggleLoader(true));
        axios.get(process.env.REACT_APP_HOST + 'user/'
            + getUserId() + '/machine/'+ machineID )
            .then(res => {
                dispatch(getSelectedMachine(res.data.content));
            }).catch(error => {
                if (error.response.status === 422) {
                    toast.error(error.response.data.message);
                }
            }
        ).finally(() => {
            dispatch(toggleLoader(false))
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedMachine]);

    useEffect(() => {
        dispatch(changeView(VIEW.REPORT_LIST));
    }, []);

    useEffect(() => {
        setReportList({});
    }, [machineID]);

    useEffect(() => {
        // Ignore responses from requests made with outdated filters or for a previous machine
        let isStale = false;
        dispatch(toggleLoader(true));
        axios.get(process.env.REACT_APP_HOST + 'user/'
            + getUserId() + '/machine/' + machineID + `/performance-dashboard?shift=` + selectedShiftType + `&reportType=CUSTOM&from=` + fromDate + '&to=' + toDate)
            .then(res => {
                if (!isStale) {
                    setReportList(res.data.content || {});
                }
            }).catch(error => {
                if (isStale) {
                    return;
                }
                setReportList({});
                if (error.response && error.response.status === 422) {
                    toast.error(error.response.data.message);
                }
            }
        ).finally(() => {
            dispatch(toggleLoader(false))
        })

        return () => {
            isStale = true;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [machineID,fromDate,toDate,selectedShiftType]);

    const onClickGraphPage = (graphType_bc, graphType) =>{
        dispatch(getSelectedReport(graphType_bc));
        storeInLocalStorage("thirdNav", graphType_bc);
        history.push('/' + departmentID + '/' + machineID +  '/' + graphType  + "/performanceGraph" );
    }

    return (
        <div>
            <div id="listView" className={'list-view full-list-view'}>
                <div className={"half-list-container margin-view-report"}>
                    <Container className="m-t-8">
                        <div className={"spy-report-container"}>
                            <Row id={"m-rl-m-18-2"}>
                                <ReportItem
                                    title={"Performance"}
                                    data={formatPercent(reportList.performance?.performance)}
                                    bodyData={{
                                        'Output': formatWithUnit(reportList.performance?.output, 'm'),
                                        'Rated Output': formatWithUnit(reportList.performance?.ratedOutput, 'm'),
                                    }}
                                    onClick={() => onClickGraphPage(REPORT_NAMES.PERFORMANCE_BC, REPORT_NAMES.PERFORMANCE)}
                                />
                                <ReportItem
                                    title={"Achievement"}
                                    data={formatPercent(reportList.achievement?.achievement)}
                                    bodyData={{
                                        'Output': formatWithUnit(reportList.achievement?.output, 'm'),
                                        'Target Output': formatWithUnit(reportList.achievement?.targetOutput, 'm'),
                                    }}
                                    onClick={() => onClickGraphPage(REPORT_NAMES.ACHIEVEMENT_BC, REPORT_NAMES.ACHIEVEMENT)}
                                />
                                <ReportItem
                                    title={"Down Time"}
                                    data={formatPercent(reportList.downtime?.downtimePercent)}
                                    bodyData={{
                                        'Pr. Time': formatWithUnit(reportList.downtime?.productionTime),
                                        'Se. Time': formatWithUnit(reportList.downtime?.setupTime),
                                        'Down Time': formatPercent(reportList.downtime?.downtimePercent),
                                    }}
                                    onClick={() => onClickGraphPage(REPORT_NAMES.DOWNTIME_BC, REPORT_NAMES.DOWNTIME)}
                                />
                                <ReportItem
                                    title={"OEE"}
                                    data={formatPercent(reportList.oee?.oee)}
                                    bodyData={{
                                        'Availability': formatPercent(reportList.oee?.availability),
                                        'Performance': formatPercent(reportList.oee?.performance),
                                        'Quality': formatPercent(reportList.oee?.quality),
                                    }}
                                    onClick={() => onClickGraphPage(REPORT_NAMES.OEE_BC, REPORT_NAMES.OEE)}
                                />
                                <ReportItem
                                    title={"Average Order Size"}
                                    data={formatRaw(reportList.averageOrderSize?.averageOrderSize)}
                                    bodyData={{
                                        'Total Output': formatWithUnit(reportList.averageOrderSize?.totalOutput, 'm'),
                                        'No of Jobs': formatWithUnit(reportList.averageOrderSize?.noOfJobs),
                                    }}
                                    onClick={() => onClickGraphPage(REPORT_NAMES.AVERAGE_ORDER_SIZE_BC, REPORT_NAMES.AVERAGE_ORDER_SIZE)}
                                />
                                <ReportItem
                                    title={"Wastage"}
                                    data={''}
                                    bodyData={{
                                        'Actual Wastage': formatWithUnit(reportList.wastage?.actualWastage),
                                        'Target Wastage': formatWithUnit(reportList.wastage?.targetWastage),
                                    }}
                                    onClick={() => onClickGraphPage(REPORT_NAMES.WASTAGE_BC, REPORT_NAMES.WASTAGE)}
                                />
                                <ReportItem
                                    title={"Utilization"}
                                    data={formatPercent(reportList.utilization?.utilization)}
                                    bodyData={{
                                        'Capacity': formatWithUnit(reportList.utilization?.capacity, 'm'),
                                        'Time': formatPercent(reportList.utilization?.time),
                                        'Lost Capacity': formatWithUnit(reportList.utilization?.lostCapacity, 'm'),
                                    }}
                                    onClick={() => onClickGraphPage(REPORT_NAMES.UTILIZATION_BC, REPORT_NAMES.UTILIZATION)}
                                />
                            </Row>
                        </div>
                    </Container>
                </div>
            </div>
        </div>
    )
};


export default ReportList
